// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rating {\r\n  font-size: 2em;\r\n}\r\n\r\n.fas {\r\n  color: gold;\r\n}\r\n\r\n.fas.fa-star-half-alt {\r\n  position: relative;\r\n  overflow: hidden;\r\n  color: gold;\r\n}\r\n\r\n.fas.fa-star-half-alt:before {\r\n  content: \"\\f089\";\r\n  position: absolute;\r\n  left: 0;\r\n  color: #ccc;\r\n}\r\n\r\n.fas.fa-star-half-alt:after {\r\n  content: \"\\f089\";\r\n  position: absolute;\r\n  left: 0;\r\n  color: gold;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
